import React from "react";

function VacancyNotFound() {
  return (
    <div className="d-flex justify-content-center flex-column h-100 text-center">
      <h3 className="mb-4">
        We are temporarily unable to display this vacancy.
      </h3>
      <h3>Please try again later.</h3>
    </div>
  );
}

export default VacancyNotFound;
